import React from "react";
import { WithDrawalCard, FieldInputDollar } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlusSquare,
  faCheckCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { Image } from "react-bootstrap";

const HeadingAndTextComponent = ({
  headingText = "",
  contentText = "",
  style = {},
}) => (
  <div style={{ ...style }}>
    <div className="textHeading">{headingText}</div>
    <div className="textWord mt-2">{contentText}</div>
  </div>
);

function RestOfTheCards(props) {
  return (
    <>
      <WithDrawalCard style={2}>
        <HeadingAndTextComponent headingText="Name" contentText="John smith" />
        <HeadingAndTextComponent
          headingText="Available balance"
          contentText="$ 9,000.00"
        />
        <HeadingAndTextComponent
          headingText="Request Amount"
          contentText={
            <>
              <FieldInputDollar />
            </>
          }
        />
      </WithDrawalCard>
    </>
  );
}

export default RestOfTheCards;
